export enum AcknowledgmentAction {
  Remove = 'remove',
  Drop = 'drop',
  SignOff = 'signOff',
  Change = 'change',
  Select = 'select',
  Refuse = 'refuse',
  Resend = 'resend',
  Add = 'add',
  SignOffAll = 'signOffAll',
}
